<script>
const NO_PRODUCT = { collection: false, shippable: false, collection_description: null, allowed_countries: null };

export default {
    name: 'FulfilmentMethodPicker',

    props: {
        // Used when the product is already known server-side (e.g. editing an existing order).
        product: {
            type: Object,
            default: null,
        },
        // Used together with selectedProductId when the product is chosen client-side
        // (e.g. the "Add Order" modal's product dropdown) — a map of product id to
        // { collection, shippable, collection_description }.
        products: {
            type: Object,
            default: () => ({}),
        },
        selectedProductId: {
            type: [String, Number],
            default: null,
        },
        // Used together with initialSkuId when the product can change client-side via a plain,
        // non-Vue sku_id <select> already on the page (the admin order edit form) — a map of sku
        // id to { collection, shippable, collection_description }. mounted() below attaches a
        // native change listener to that <select> since it isn't part of this component's own
        // template and has no v-model of its own.
        skuProducts: {
            type: Object,
            default: null,
        },
        initialSkuId: {
            type: [String, Number],
            default: null,
        },
        initialValue: {
            type: String,
            default: null,
        },
    },

    data() {
        return {
            fulfilmentMethod: this.initialValue || null,
            selectedSkuId: this.initialSkuId || null,
        };
    },

    computed: {
        currentProduct() {
            if (this.skuProducts && this.selectedSkuId && this.skuProducts[this.selectedSkuId]) {
                return this.skuProducts[this.selectedSkuId];
            }

            if (this.product) {
                return this.product;
            }

            if (this.selectedProductId && this.products[this.selectedProductId]) {
                return this.products[this.selectedProductId];
            }

            return NO_PRODUCT;
        },

        showChooser() {
            return !!(this.currentProduct.collection && this.currentProduct.shippable);
        },

        requiresAddress() {
            if (this.showChooser) {
                return this.fulfilmentMethod === 'delivery';
            }

            return !!this.currentProduct.shippable;
        },
    },

    watch: {
        selectedProductId() {
            // A previously chosen method must not silently carry over to a newly selected product.
            this.fulfilmentMethod = null;
        },
        selectedSkuId() {
            // Same guard as selectedProductId above, for the skuProducts mode: a method chosen for
            // the order's original product must not silently validate against a newly picked one.
            this.fulfilmentMethod = null;
        },
    },

    mounted() {
        if (!this.skuProducts) {
            return;
        }

        const select = document.querySelector('select[name="sku_id"]');
        if (!select) {
            return;
        }

        select.addEventListener('change', () => {
            this.selectedSkuId = select.value;
        });
    },
};
</script>



// WEBPACK FOOTER //
// src/Assets/components/Orders/FulfilmentMethodPicker.vue